// Acción del audit log (changeType del back) → etiqueta legible. Sin etiqueta, se muestra la clave.
export const AUDIT_ACTION_LABELS: Record<string, string> = {
    CREATE: 'Creación',
    UPDATE: 'Actualización',
    DELETE: 'Eliminación',
    ROLE_ASSIGN: 'Asignación de rol',
    ROLE_REVOKE: 'Retiro de rol',
    STATUS_CHANGE: 'Cambio de estado',
    MFA_RESET: 'Restablecimiento del segundo factor',
    SECURITY_POLICY_UPDATE: 'Cambio de política de seguridad',
    TENANT_CREATED: 'Alta de organización',
    POOL_CREATED: 'Alta de pool de usuarios',
    ADMIN_ASSIGNED: 'Asignación de administrador',
    LOGIN_ATTEMPT: 'Intento de inicio de sesión',
    LOGIN_SUCCESS: 'Inicio de sesión',
    LOGIN_FAIL: 'Inicio de sesión fallido',
    LOGIN_ATTEMPT_PARTIAL: 'Inicio de sesión incompleto',
    MFA_TOTP_VERIFIED: 'Código de autenticación verificado',
    MFA_PREFERENCE_UPDATED: 'Cambio de preferencia del segundo factor',
    MFA_SETUP_TOTP_BEGUN: 'Inicio de configuración de app autenticadora',
    EMAIL_CHANGE_INITIATED: 'Solicitud de cambio de correo',
    EMAIL_CHANGE_CONFIRMED: 'Cambio de correo confirmado',
    PROFILE_UPDATED: 'Actualización de perfil',
    INVITATION_RESENT: 'Reenvío de invitación',
    CASCADE_RECOMPUTE: 'Recálculo del alcance de roles',
    CASCADE_ROLES: 'Propagación de roles de la aplicación',
};

// Opciones del filtro de acción, en el orden del mapa.
export const AUDIT_ACTION_OPTIONS = Object.keys(AUDIT_ACTION_LABELS);

// Detalle que el back guarda en `after.action` cuando la acción real es genérica (STATUS_CHANGE).
export const AUDIT_DETAIL_ACTION_LABELS: Record<string, string> = {
    PASSWORD_RESET: 'Restablecimiento de contraseña',
    SELF_REGISTER_STARTED: 'Inicio de autorregistro',
    SELF_REGISTER_OTP_VERIFIED: 'Código de autorregistro verificado',
    SELF_REGISTER_OTP_RESENT: 'Reenvío del código de autorregistro',
};

export function auditActionLabel(action: string): string {
    return Object.prototype.hasOwnProperty.call(AUDIT_ACTION_LABELS, action)
        ? AUDIT_ACTION_LABELS[action]
        : action;
}

/** Etiqueta de la acción de una fila: el detalle de `after.action` si es conocido, si no la acción. */
export function auditRowActionLabel(action: string, after: unknown): string {
    const detail =
        after && typeof after === 'object' ? (after as { action?: unknown }).action : undefined;
    if (typeof detail === 'string' && Object.hasOwn(AUDIT_DETAIL_ACTION_LABELS, detail)) {
        return AUDIT_DETAIL_ACTION_LABELS[detail];
    }
    return auditActionLabel(action);
}
